module.exports = __webpack_public_path__ + "static/media/x_icon.e0fa8231.svg";